import { motion } from "framer-motion";

import BasicMotion from "../Motion/BasicMotion";

function FadingBalls(props) {
    const { text, alert, Alert } = props;

    return (
        <BasicMotion>
            <div className={"flex flex-col gap-8 justify-center items-center h-screen"}>
                <div className="flex flex-row gap-1">
                    <motion.div
                        className={"bg-primary-600 h-12 w-12 rounded-full"}
                        animate={{ opacity: [0, 1, 0], scale: [0.5, 1, 0.5] }}
                        transition={{
                            duration: 1.6,
                            ease: "easeInOut",
                            repeat: Infinity,
                            delay: 0.25,
                        }}
                    />
                    <motion.div
                        className={"bg-secondary-300 h-12 w-12 rounded-full"}
                        animate={{ opacity: [0, 1, 0], scale: [0.5, 1, 0.5] }}
                        transition={{
                            duration: 1.6,
                            ease: "easeInOut",
                            repeat: Infinity,
                        }}
                    />
                    <motion.div
                        className={"bg-primary-600 h-12 w-12 rounded-full"}
                        animate={{ opacity: [0, 1, 0], scale: [0.5, 1, 0.5] }}
                        transition={{
                            duration: 1.6,
                            ease: "easeInOut",
                            repeat: Infinity,
                            delay: 0.5,
                        }}
                    />
                </div>
                <div className="h-11">
                    {alert ? Alert : <div className={"text-md text-blue-gray-500"}>{text ? text : "Loading..."}</div>}
                </div>
            </div>
        </BasicMotion>
    );
}

export default FadingBalls;
